<template>
  <component :is="activeComponent" />
</template>

<script>
import StandardOrderCheckout from "./OrderCheckout/StandardOrderCheckout.vue";
import store from "@/store/store";

export default {
  name: "OrderCheckoutSwitcher",
  components: {
    StandardOrderCheckout,
  },
  computed: {
    activeComponent() {
      return "StandardOrderCheckout";
    },
  },
  beforeRouteEnter(to, from, next) {
    const proceed = () => {
      if (store.getters["config/isKioskMode"]) {
        next({
          name: "OrderCheckoutV2",
          params: to.params,
          query: to.query,
          replace: true
        });
      } else {
        next();
      }
    };
    if (!store.getters["config/terminal"]) {
      store.dispatch("config/fetchTerminal").then(proceed).catch(() => next());
    } else {
      proceed();
    }
  }
};
</script>
